import type { SosEventResponse } from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const resolveSosSessions = createActionSet<
	SosEventResponse.AsObject[],
	SosEventResponse.AsObject[]
>("sos/resolve");
